import React, { FC, ReactNode } from "react";
import imagePng from "images/hero-testimonials.png";
import HeroSearchForm, {
  SearchTab,
} from "components/HeroSearchForm/HeroSearchForm";
import Avatar from "shared/Avatar/Avatar";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";

export interface SectionHeroArchivePageProps {
  className?: string;
  listingType?: ReactNode;
  currentPage: "Stays" | "Experiences" | "Cars" | "Flights";
  currentTab: SearchTab;
  rightImage?: string;
}

const SectionHeroArchivePage: FC<SectionHeroArchivePageProps> = ({
  className = "",
  listingType,
  currentPage,
  currentTab,
  rightImage = imagePng,
}) => {
  return (
    <div
      className={`nc-SectionHeroArchivePage flex flex-col relative  ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      <div className="flex flex-col lg:flex-row lg:pt-[10px]">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-6 lg:space-y-10 pb-10 lg:pb-64 xl:pb-80 xl:pr-14  xl:mr-0">
          <h2 className="text-3xl md:text-4xl font-semibold ">
            Testimonials
          </h2>
          <div className=" w-[365px] font-normal text-base  text-neutral-500">
          Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
          </div>
          {/* <div className="flex items-center text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            <i className="text-2xl las la-map-marked"></i>
            <span className="ml-2.5">Jappan </span>
            <span className="mx-5"></span>
            {listingType ? (
              listingType
            ) : (
              <>
                <i className="text-2xl las la-home"></i>
                <span className="ml-2.5">112 properties</span>
              </>
            )}
          </div> */}
        </div>
        <div className="flex flex-row justify-center items-center pb-[35px]">
        {/* <div className="flex-col bg-[#2FD500]"> */}
        <div className="flex-col ">
            <div className="m-[15px]  p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                <div className="flex items-center space-x-4 ">
                            <Avatar
                              hasChecked
                              hasCheckedClass="w-0 h-0 "
                              sizeClass="h-[70px] w-[70px]"
                              radius="rounded-full"
                            />
                            <div >
                                <a className="block text-md font-semibold">
                                  Andrew
                                </a>
                                <a className="block text-md font-semibold mt-[-3px]">
                                  Tatezendre
                                </a>
                                
                            </div>  
                 </div>
                 <div className=" py-[10px] ">
                              <FiveStartIconForRate iconClass="w-3 h-3" className="space-x-0.5" />
                 </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                       Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
                  </div>
            </div> 
            <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                 <div className="flex items-center space-x-4 ">
                            <Avatar
                              hasChecked
                              hasCheckedClass="w-0 h-0 "
                              sizeClass="h-[70px] w-[70px]"
                              radius="rounded-full"
                            />
                            <div >
                                <a className="block text-md font-semibold">
                                  Andrew
                                </a>
                                <a className="block text-md font-semibold mt-[-3px]">
                                  Tatezendre
                                </a>
                                
                            </div>  
                 </div>
                 <div className=" py-[10px] ">
                              <FiveStartIconForRate iconClass="w-3 h-3" className="space-x-0.5" />
                 </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                       Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
                  </div>
            </div> 
        </div> 
        {/* <div className="flex-col bg-[#FFC62B] pt-[80px]"> */}
        <div className="hidden md:block flex-col  pt-[80px]">
             <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                            <Avatar
                              hasChecked
                              hasCheckedClass="w-0 h-0 "
                              sizeClass="h-[70px] w-[70px]"
                              radius="rounded-full"
                            />
                            <div >
                                <a className="block text-md font-semibold">
                                  Andrew
                                </a>
                                <a className="block text-md font-semibold mt-[-3px]">
                                  Tatezendre
                                </a>
                                
                            </div>  
                 </div>
                 <div className=" py-[10px] ">
                              <FiveStartIconForRate iconClass="w-3 h-3" className="space-x-0.5" />
                 </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                       Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
                  </div>
            </div>
            <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                 <div className="flex items-center space-x-4 ">
                            <Avatar
                              hasChecked
                              hasCheckedClass="w-0 h-0 "
                              sizeClass="h-[70px] w-[70px]"
                              radius="rounded-full"
                            />
                            <div >
                                <a className="block text-md font-semibold">
                                  Andrew
                                </a>
                                <a className="block text-md font-semibold mt-[-3px]">
                                  Tatezendre
                                </a>
                                
                            </div>  
                 </div>
                 <div className=" py-[10px] ">
                              <FiveStartIconForRate iconClass="w-3 h-3" className="space-x-0.5" />
                 </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                       Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
                  </div>
            </div>  
        </div>  
          {/* <img className="w-full" src={rightImage} alt="hero" /> */}
        </div>
      </div>

     
    </div>
  );
};

export default SectionHeroArchivePage;
